import apiAxios from '@/services/axiosConfig';

async function deleteConnection(uuid: string): Promise<void> {
  await apiAxios.delete(`/api/v1/mt/connections/${uuid}`);
}

export default deleteConnection;
